
<div class="carousel" *ngIf="data?.blockData">
    <div class="carousel-header" *ngIf="hasHeader">
        <finder-component-header
            [data]="data.headerData"
        ></finder-component-header>
    </div>
    <div class="carousel-content">
        <div class="arrow prev">
            <a class="navlink"
                tabindex="0"
                (click)="setActive(currentIndex - 1)"
                (keyup.enter)="setActive(currentIndex - 1)"
                [attr.aria-label]="labelsSig()?.prevSlide"
                [attr.title]="labelsSig()?.prevSlide"
            ><finder-font-icon
                [name]="prevArrow"
            ></finder-font-icon></a>
        </div>
        <div class="carousel-body">
            <finder-carousel-content-renderer
                [blocks]="data.blockData"
            ></finder-carousel-content-renderer>
            <div aria-live="polite" aria-atomic="true" class="visually-hidden">
                {{ slideAnnouncementData | slideAnnouncement: currentIndex }}
            </div>
            <div class="carousel-nav">
                <a class="navlink" *ngFor="let item of items; let idx = index"
                    [class.active]="currentIndex === idx"
                    (click)="setActive(idx)"
                    (keyup.enter)="setActive(idx)"
                    [attr.aria-label]="slideAnnouncementData | slideAnnouncement: idx"
                    tabindex="0"
                >&#9679;</a>
            </div>
        </div>
        <div class="arrow next">
            <a class="navlink"
                tabindex="0"
                (click)="setActive(currentIndex + 1)"
                (keyup.enter)="setActive(currentIndex + 1)"
                [attr.aria-label]="labelsSig()?.nextSlide"
                [attr.title]="labelsSig()?.nextSlide"
            ><finder-font-icon
                [name]="nextArrow"
            ></finder-font-icon></a>
        </div>
    </div>
    <div class="carousel-nav" *ngIf="externalNav" [attr.aria-hidden]="true">
        <a *ngFor="let item of items; let idx = index"
            class="navlink"
            tabindex="0"
            [class.active]="currentIndex === idx"
            (click)="setActive(idx)"
            (keyup.enter)="setActive(idx)"
        >&#9679;</a>
    </div>
</div>
